import Link from 'next/link';
import { useIntl } from 'react-intl';

import IconGradientBorder from '@/components/app/sidebar/IconGradientBorder';
import { useLoginForm } from '@/hooks/forms';

import { ChevronRight, IconWrapper, Label, Wrapper } from './styles';
import { ProfileMenuItemProps } from './types';

const InnerMenuItem = ({ name, colors, Icon }: Omit<ProfileMenuItemProps, 'route' | 'isLogout'>) => {
	const { formatMessage } = useIntl();

	return (
		<>
			<IconGradientBorder
				id={`${name.defaultMessage?.replace(' ', '')}ProfileIconBorder`}
				colors={colors}
				isActive={false}
				size={36}
			>
				<IconWrapper>
					<Icon />
				</IconWrapper>
			</IconGradientBorder>
			<Label>{formatMessage(name)}</Label>
			<ChevronRight />
		</>
	);
};

const MenuItem = ({ route, isLogout, shouldOpenInNewTab, ...props }: ProfileMenuItemProps) => {
	const { onLogout } = useLoginForm();

	if (isLogout) {
		return (
			<Wrapper onClick={onLogout} as="button">
				<InnerMenuItem {...props} />
			</Wrapper>
		);
	}

	if (typeof route !== 'string') return null;

	return (
		<Link passHref href={route} legacyBehavior>
			<Wrapper {...(shouldOpenInNewTab && { target: '_blank' })}>
				<InnerMenuItem {...props} />
			</Wrapper>
		</Link>
	);
};

export default MenuItem;
